import { useQuery } from "@apollo/client";
import { GET_WISHLIST_DATA } from "./wishlist.gql";
import { useSelector } from "react-redux";

export const useGetWishlist = () => {
  const { isSignedIn } = useSelector((state) => state.loginSlice);
  const { loading, error, data } = useQuery(GET_WISHLIST_DATA, {
    skip: !isSignedIn,
  });

  const wishlistId =
    data &&
    data.customer &&
    data.customer.wishlists &&
    data.customer.wishlists[0] &&
    data.customer.wishlists[0].id
      ? data.customer.wishlists[0].id
      : "";

  const wishlistData =
    data &&
    data.customer &&
    data.customer.wishlists &&
    data.customer.wishlists[0] &&
    data.customer.wishlists[0].items_v2 &&
    data.customer.wishlists[0].items_v2.items
      ? data.customer.wishlists[0].items_v2.items
      : [];

  return {
    loading,
    error,
    wishlistId,
    wishlistData,
  };
};
